import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { ArrowForwardIos } from "@material-ui/icons";
import {
  Dialog,
  DialogContent,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  DialogTitle,
  Typography,
} from "@material-ui/core";
import { locales } from "../../config/i18n";
import { getLocaleFromCookie } from "../../utils/getLocaleFromCookie";
import { setLocaleCookie } from "../../utils/setLocaleCookie";
import { flagsI18N } from "./Flags";

const LocaleSelectorModal: React.FC = () => {
  const [open, setOpen] = useState<boolean>(false);
  const { t, i18n } = useTranslation();
  const locale = getLocaleFromCookie();

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (locale === "en_??") {
      setOpen(true);
    } else {
      setOpen(false);
    }
  });

  type HandleClose = () => void;
  const handleClose: HandleClose = () => {
    setOpen(false);
  };

  type HandleClick = (locale: string, language: string) => void;
  const handleClick: HandleClick = (locale, language) => {
    setLocaleCookie(locale);
    i18n.changeLanguage(language);
  };

  return (
    <Dialog
      open={open}
      onClose={(): void => handleClose()}
      data-testid="localeSelectorModal"
      maxWidth="md"
    >
      <DialogTitle>
        <Typography
          variant="h2"
          style={{ fontWeight: 700 }}
          data-testid="localeSelectorModalHeader"
        >
          {t("localeSelector.title")}
        </Typography>
      </DialogTitle>
      <DialogContent style={{ minWidth: 300, maxHeight: 400 }}>
        <List data-testid="localeSelectorList" disablePadding>
          {locales.map((locale) => {
            const [language, country] = locale.toLowerCase().split("_");
            const countryUppercase = country.toUpperCase();
            return (
              <ListItem
                divider
                dense
                button
                component="div"
                data-testid={`localeSelectorItem_${locale}`}
                key={locale}
                onClick={(): void => handleClick(locale, language)}
              >
                <ListItemIcon style={{ minWidth: "36px" }}>
                  <img src={flagsI18N[country]} alt="" height="20" />
                </ListItemIcon>
                <ListItemText
                  primary={t(`countries.${countryUppercase}`)}
                  secondary={t(`languages.${language}`)}
                />
                <ArrowForwardIos color="disabled" />
              </ListItem>
            );
          })}
        </List>
      </DialogContent>
    </Dialog>
  );
};

export default LocaleSelectorModal;
